import { parseHostnameFromEnv } from './brandFromHost'
import {
  isWysehubAdminHostname as isWysehubAdminHostnameFromRequest,
  isWysehubPortalHostname as isWysehubPortalHostnameFromRequest,
} from './managedHosts'

const WYSEHUB_PUBLIC_ENTRY_PATHS = new Set([
  '/',
  '/recover-password',
  '/reset-password',
  '/unauthorised',
  '/unlockconfirmation',
])

export function getWysehubPortalHostname(): string {
  return parseHostnameFromEnv(process.env.NEXT_PUBLIC_WYSEHUB_PORTAL_HOST)
}

export function getWysehubAdminHostname(): string {
  return parseHostnameFromEnv(process.env.NEXT_PUBLIC_WYSEHUB_ADMIN_HOST)
}

export function isWysehubPortalHost(hostname: string): boolean {
  if (isWysehubPortalHostnameFromRequest(hostname)) {
    return true
  }
  const configuredHost = getWysehubPortalHostname()
  return (
    !!configuredHost &&
    normalizeHostname(hostname) === configuredHost.toLowerCase()
  )
}

export function isWysehubAdminHost(hostname: string): boolean {
  if (isWysehubAdminHostnameFromRequest(hostname)) {
    return true
  }
  const configuredHost = getWysehubAdminHostname()
  return (
    !!configuredHost &&
    normalizeHostname(hostname) === configuredHost.toLowerCase()
  )
}

function normalizeHostname(hostname: string): string {
  return hostname.toLowerCase().replace(/:\d+$/, '').replace(/^www\./, '')
}

export function isWysehubAdminPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/')
}

export function getWysehubAdminAliasPath(pathname: string): string | null {
  if (pathname === '/rates') {
    return '/admin/rates'
  }

  if (pathname === '/source_rates') {
    return '/admin/source-rates'
  }

  return null
}

export function isWysehubPublicEntryPath(pathname: string): boolean {
  return WYSEHUB_PUBLIC_ENTRY_PATHS.has(pathname)
}
